export const config = {
  eventGroup: 'jxsj_zlp_pc_20260714',
  name: '《剑侠世界》端游26年7月资料片',
  identify: 'jxsj2',
  eventTags: ['jxsj', 'zlp']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function () {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function () {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function () {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickGoWebsite: function () {
      report({
        eventName: 'click_go_website',
        eventDescription: '点击进入官网'
      });
    },
    clickDownload: function () {
      report({
        eventName: 'click_download',
        eventDescription: '点击下载游戏'
      });
    },
    /**
     * @param {string} [title] - 导航名称
     */
    clickMenu: function (title) {
      report({
        eventName: 'click_menu',
        eventDescription: '点击内页导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
